export function UniqueIdentifierGenerator () {
  let nextValue = 0

  this.nextValue = function () {
    return nextValue++
  }
}
